import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const received = createAsyncThunk(
  "received/fetch",
  async (page, { rejectWithValue, serializeError }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/GetEsignLogReceived?page=${page}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);


const receivedSlice = createSlice({
  name: "received",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(received.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(received.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(received.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default receivedSlice.reducer;
